var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.414,
    height: 34.707,
    viewBox: "0 0 20.414 34.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-949.793 -963.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M1,32H-1V0H1Z",
    transform: "translate(960 963.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    "data-name": "Line 7",
    d: "M9.293,10.707l-12-12,1.414-1.414,12,12Z",
    transform: "translate(952.5 987.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M.707,10.707-.707,9.293l12-12,1.414,1.414Z",
    transform: "translate(957.5 987.5)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1bba492b805c93662d9ce2aa1e123ee6.svg";
export { ForwardRef as ReactComponent };